export const validarCampo = ({min=3, max=25, texto}) => {

    if (!texto && min > 0) {
        return 'N/A'
    }

    if (texto.length < max && texto.length > 0) {
        return texto
    } else {
        return texto.substring(0, max)
    }


}